import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import {
    devConfig, // Importing development configuration
    countries, // Importing countries data
    profile, // Importing user profile data
    cashDesks, // Importing cash desks data
    agentList, // Importing agent list data
} from 'config/config'; // Importing configuration settings

/**
 * FilterFlujoCajaView class extends JetView to create a filter view for cash flow.
 */
export default class FilterFlujoCajaView extends JetView {
    /**
     * Configures the UI components of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const left = {
            // Left section configuration
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha"), // Label for datepicker
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };
        const center_left = {
            // Center left section configuration
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for country selection
                    name: 'CountrySelect',
                    id: 'CountrySelect',
                    localId: 'regions:combo',
                    label: _("<span class='icon-language'></span> País"), // Label for country select
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: {
                        body: {
                            template: function (obj) {
                                // Custom template for displaying country flags
                                return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                            },
                            data: countries, // Data source for countries
                        },
                    },
                    // Conditional visibility based on configuration
                    hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                    css: 'prm-filterByCountry', // CSS class for styling
                },
                {
                    view: 'richselect', // Read-only dropdown for selected country
                    name: 'CountrySelect2',
                    localId: 'regions:combo',
                    label: _("<span class='icon-language'></span> País"), // Label for country select
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: profile.Settings.ReportCountry, // Default value from profile settings
                    readonly: true,
                    options: {
                        body: {
                            template: function (obj) {
                                // Custom template for displaying country flags
                                return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                            },
                            data: countries, // Data source for countries
                        },
                    },
                    // Conditional visibility based on configuration
                    hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                    css: 'prm-filterByCountry', // CSS class for styling
                },
            ],
        };
        const center_right = {
            // Center right section configuration
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for ticket number
                    name: 'NoTicket',
                    label: _("<span class='icon-ticket'></span> No. Ticket"), // Label for ticket number
                    labelPosition: 'top',
                    placeholder: _('No. Ticket'), // Placeholder text
                    invalidMessage: _('No. Ticket is required'), // Validation message
                    type: 'number', // Input type
                },
            ],
        };
        const right = {
            // Right section configuration (currently empty)
            margin: 5,
            minWidth: 200,
            rows: [],
        };
        const upper_section = {
            // Upper section containing the filter inputs
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout of the upper section
                },
            ],
        };
        const buttons = {
            // Button section configuration
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    click: () => {
                        // Click event to clear the form
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Click event to submit the filter
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            // Check if country report is enabled
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter
                        }
                        delete filterdata['CountrySelect2']; // Remove unused country select
                        this.app.callEvent('flujoCaja:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };
        return {
            // Return the complete form configuration
            view: 'form',
            scroll: 'y',
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and fetches agent countries data.
     * @param {Object} form - The form object.
     */
    init(form) {
        webix
            .ajax() // AJAX request to fetch agent countries
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                // POST request to API
                error: function (text, data, XmlHttpRequest) {
                    // Error handling
                    webix.message('Error! '); // Display error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handling
                    var data = JSON.parse(
                        // Parse the response data
                        text
                            .replace(/"Id"/g, '"id"') // Normalize key names
                            .replace(/"Name"/g, '"value"'),
                    );
                    var optionsProvinceRegions = $$('country').getList(); // Get the country list component
                    optionsProvinceRegions.clearAll(); // Clear existing options
                    optionsProvinceRegions.parse(data.Data); // Populate with new data
                },
            });
    }
}

// FILE DOCUMENTED
